
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

const vesselsStore = namespace('vessels')

// V3Page is registered globally in App.vue: V3Page indirectly imports the V3Wrappers dialogs, so a local import
// can still be undefined when this module loads
@Component
export default class UnregisteredVesselCreatorDialog extends Vue {
	@vesselsStore.Action('findRecord')
	findRecord

	// The V3 vessel form hands back the new vessel's id on save, and nothing on cancel
	async onCloseDialog(args: { vesselId?: string } | null) {
		if (!args?.vesselId) {
			this.$emit('closing')
			return
		}

		// Caches the vessel too, so SpecificVesselPicker can show it
		const vessel = await this.findRecord(args.vesselId)

		this.$emit('vesselCreated', vessel)
	}
}
